// ==== ショピ村 歩行マップ ====
// map_layout（テキストのタイル表）をグリッドに変換し、Canvas上でキャラを
// 1マスずつスムーズに歩かせる。施設ブロックのタイルに乗ると入場プロンプトを出す。
const RPG_VILLAGE_TILE_SIZE = 32;
const RPG_VILLAGE_VIEWPORT_COLS = 15;
const RPG_VILLAGE_VIEWPORT_ROWS = 11;
// スマホ（縦長画面）では横幅はそのままに縦の表示マス数だけ増やして画面を埋める。
// canvasを拡大してCSSで左右をはみ出させて隠す方式は、clampCameraが常に15列全体が
// 画面内に見えている前提のためカメラとズレて動かなくなるバグがあり、不採用にした
const RPG_VILLAGE_VIEWPORT_ROWS_MOBILE = 20;
const RPG_VILLAGE_MOBILE_QUERY = window.matchMedia('(max-width: 768px)');
const RPG_VILLAGE_MOVE_MS = 220; // 1マス移動にかかる時間
const RPG_VILLAGE_VILLAGER_MOVE_MS = 420; // 村人（NPC）が1マス移動するのにかかる時間（勇者より少しゆっくり）
const RPG_VILLAGE_VILLAGER_IDLE_MIN_MS = 800;
const RPG_VILLAGE_VILLAGER_IDLE_RANGE_MS = 2200; // 待機時間 = MIN 〜 MIN+RANGE のランダム
const RPG_VILLAGE_VILLAGER_STAY_CHANCE = 0.35; // 移動を試みるタイミングでも、この確率でその場に留まる
const RPG_VILLAGE_NPC_SCALE = 0.8; // 1マスに対する村人の見た目サイズの倍率

// 上下左右の移動ベクトル。矢印キー・十字ボタン・村人のランダム移動で共通して使う
const RPG_VILLAGE_DIRECTIONS = {
  up: { dr: -1, dc: 0, facing: 'up' },
  down: { dr: 1, dc: 0, facing: 'down' },
  left: { dr: 0, dc: -1, facing: 'left' },
  right: { dr: 0, dc: 1, facing: 'right' },
};

// 村人にぶつかった時、村人を勇者側へ向き直らせるための「逆向き」対応表
// （勇者が'up'に進んでぶつかった＝村人は勇者の上にいる＝村人は'down'を向いて勇者を見る）
const RPG_VILLAGE_OPPOSITE_FACING = { up: 'down', down: 'up', left: 'right', right: 'left' };

// 「ぴぽや」形式のキャラチップ（96x128px、3列4行＝歩行3コマ×下左右上4方向、32px角）の
// 向き（facing）→ 参照する行（row）の対応表。村人（NPC）の描画で使う
const RPG_VILLAGE_CHARACHIP_ROW_BY_FACING = { down: 0, left: 1, right: 2, up: 3 };

// 勇者のキャラチップ画像は、左向きの行と右向きの行が村人素材と逆になっているため、
// 勇者の描画だけはこちらの対応表を使う
const RPG_VILLAGE_PLAYER_ROW_BY_FACING = { down: 0, left: 2, right: 1, up: 3 };

// タイル文字の意味（テーマエディターのmap_layoutテキストエリアで使う記法）
// '.' 草原（進入可） / ',' 道（進入可） / '#' 壁・横向き（進入不可） / '|' 壁・縦向き（進入不可） / '~' 水（進入不可） / '^' 山（進入不可） / 'T' 木（進入不可）
// 城は1マスに収まらない（2x2マス）ため、4つの記号（1=左上 2=右上 3=左下 4=右下）を
// map_layout上で2行2列に並べて配置する（進入不可）
const RPG_VILLAGE_WALKABLE_CHARS = new Set(['.', ',']);
const RPG_VILLAGE_CASTLE_CHARS = new Set(['1', '2', '3', '4']);
const RPG_VILLAGE_TILE_COLORS = {
  '.': '#7ec850',
  ',': '#d8c48a',
  '#': '#5a5850',
  '|': '#5a5850',
  '~': '#4a90d9',
  '^': '#8a8577',
  'T': '#d8c48a',
  '1': '#9aa6b8',
  '2': '#9aa6b8',
  '3': '#9aa6b8',
  '4': '#9aa6b8',
};

// テロップ（アイコン＋話者名＋セリフ＋クリック/Enterで次へ）。オープニング会話と施設・村人の
// 会話ポップアップの両方をこの1つのUIで再生する（同時に再生できるのは1つだけ）。話者名は
// 「話者名「セリフ」」という全角カギ括弧の表記から自動で切り出す
class RPGVillageTelop {
  constructor({ overlayEl, iconEl, nameEl, textEl, onComplete }) {
    this.overlayEl = overlayEl;
    this.iconEl = iconEl;
    this.nameEl = nameEl;
    this.textEl = textEl;
    this.onComplete = onComplete; // 最後まで読み終えて閉じた時に呼ぶコールバック
    this.lines = [];
    this.index = 0;
    this.active = false;
  }

  // lines: [{ icon, text }] の配列。空なら何もしない
  play(lines) {
    if (!this.overlayEl || !lines || lines.length === 0) return;
    this.lines = lines;
    this.index = 0;
    this.active = true;
    this.overlayEl.hidden = false;
    this.showLine(0);
  }

  showLine(index) {
    const line = this.lines[index];
    if (!line) return;
    if (this.iconEl) {
      if (line.icon) {
        this.iconEl.src = line.icon;
        this.iconEl.hidden = false;
      } else {
        this.iconEl.hidden = true;
      }
    }
    const { name, body } = this.splitSpeaker(line.text || '');
    if (this.nameEl) {
      if (name) {
        this.nameEl.textContent = name;
        this.nameEl.hidden = false;
      } else {
        this.nameEl.hidden = true;
      }
    }
    if (this.textEl) this.textEl.textContent = body;
  }

  splitSpeaker(text) {
    const match = text.match(/^(.+?)「(.+)」$/);
    if (!match) return { name: '', body: text };
    return { name: match[1], body: match[2] };
  }

  advance() {
    this.index++;
    if (this.index >= this.lines.length) {
      this.active = false;
      if (this.overlayEl) this.overlayEl.hidden = true;
      if (this.onComplete) this.onComplete();
      return;
    }
    this.showLine(this.index);
  }
}

class RPGVillageMap {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.storageKey = `rpg_village_pos_${this.sectionId}`;

    this.canvas = root.querySelector('[data-role="rpg-village-canvas"]');
    this.ctx = this.canvas ? this.canvas.getContext('2d') : null;
    this.bgmEl = root.querySelector('[data-role="rpg-village-bgm"]');
    this.bgmToggleEl = root.querySelector('[data-role="rpg-village-bgm-toggle"]');
    this.bgmEnabled = true;
    this.entryPromptEl = root.querySelector('[data-role="rpg-village-entry-prompt"]');
    this.entryLinkEl = root.querySelector('[data-role="rpg-village-entry-link"]');
    this.entryImageEl = root.querySelector('[data-role="rpg-village-entry-image"]');
    this.entryTitleEl = root.querySelector('[data-role="rpg-village-entry-title"]');
    this.entryDescEl = root.querySelector('[data-role="rpg-village-entry-desc"]');
    this.entryChoicesEl = root.querySelector('[data-role="rpg-village-entry-choices"]');
    this.exitYesBtn = root.querySelector('[data-role="rpg-village-exit-yes"]');
    this.exitNoBtn = root.querySelector('[data-role="rpg-village-exit-no"]');
    this.loadingEl = root.querySelector('[data-role="rpg-village-loading"]');
    this.castleMessage = root.dataset.castleMessage || '';
    this.castleIconUrl = root.dataset.castleIcon || '';

    this.introLines = this.parseIntroLines(root);
    this.eventVisitCounts = {}; // 会話ポップアップ（施設・村人）ごとの会話パターン順番送り用カウンタ（id -> 回数）
    this.telop = new RPGVillageTelop({
      overlayEl: root.querySelector('[data-role="rpg-village-intro-overlay"]'),
      iconEl: root.querySelector('[data-role="rpg-village-intro-icon"]'),
      nameEl: root.querySelector('[data-role="rpg-village-intro-name"]'),
      textEl: root.querySelector('[data-role="rpg-village-intro-text"]'),
      onComplete: () => {
        // テロップ表示中は隠していた入場プロンプトを、閉じたタイミングで改めて反映する
        this.activeFacility = undefined;
        this.checkFacilityAtCurrentTile();
      },
    });

    this.map = this.parseMap(root);
    this.facilities = this.parseFacilities(root);
    this.villagers = this.parseVillagers(root);
    this.images = this.parseImages(root);
    this.loadedImages = {};

    const startRow = parseInt(root.dataset.startRow, 10) || 0;
    const startCol = parseInt(root.dataset.startCol, 10) || 0;
    this.startRow = startRow;
    this.startCol = startCol;
    const saved = this.loadSavedPosition();
    this.tileRow = saved ? saved.row : this.clampRow(startRow);
    this.tileCol = saved ? saved.col : this.clampCol(startCol);
    // 保存済みの現在地がある＝再訪問なので、毎回オープニング会話を押させられるのは煩わしい。
    // 初回訪問（保存データなし）の時だけオープニングテロップを再生する
    this.isFirstVisit = !saved;

    this.moveDirection = null; // RPG_VILLAGE_DIRECTIONSのいずれか。移動中の方向（nullなら静止）
    this.moveProgress = 0;
    this.facing = 'down';
    this.heldDirections = []; // 押されている方向キーを押下順に保持（後勝ち）
    this.suppressTelopClick = false; // 十字ボタン操作中に発生するclickでテロップを進めさせないためのフラグ
    this.activeFacility = null;
    this.lastFrameTime = null;
    this.viewportRows = this.computeViewportRows();

    // 画像（タイル・施設・村人・会話アイコン等）を全て読み込み終えてから操作を有効にする。
    // そうしないと、会話テロップのアイコンなどが表示された後に読み込まれてポップインして見える
    this.preloadImages().then(() => this.start());
  }

  // 入力バインド・描画ループの開始。画像の先読み完了後に一度だけ呼ばれる
  start() {
    if (this.loadingEl) this.loadingEl.hidden = true;

    this.bindKeyboard();
    this.bindDpad();
    this.bindEntryPrompt();
    this.bindExitChoices();
    this.bindTelop();
    this.bindFocus();
    this.bindBgm();

    this.setupCanvasScale();
    window.addEventListener('resize', () => {
      this.setupCanvasScale();
      // リサイズでcanvasの実表示サイズが変わると、施設アイコン基準のプロンプト位置もズレるので引き直す
      if (this.activeFacility && this.entryPromptEl && !this.entryPromptEl.hidden) {
        if (this.activeFacility.isExit) {
          this.positionPromptRightOfFacility(this.activeFacility);
        } else {
          this.positionPromptNearFacility(this.activeFacility);
        }
      }
    });
    // スマホ⇔PCの境界をまたいだ時（画面回転・ウィンドウ幅変更）に表示マス数を切り替える
    RPG_VILLAGE_MOBILE_QUERY.addEventListener('change', () => {
      this.viewportRows = this.computeViewportRows();
      this.setupCanvasScale();
    });

    this.checkFacilityAtCurrentTile();
    this.frameHandle = requestAnimationFrame((t) => this.tick(t));
  }

  // ---- データ読み込み ----
  parseMap(root) {
    // scriptタグではなくsection要素のdata-map-layout属性から読む（理由はliquid側のコメント参照）
    const raw = root.dataset.mapLayout || '';
    const lines = raw.replace(/\r\n/g, '\n').split('\n').filter((line, index, arr) => {
      // 前後の完全な空行だけ除去する（意図的な空白マス行は保持したいので中間行は残す）
      if (line.trim() !== '') return true;
      return index !== 0 && index !== arr.length - 1;
    });
    const width = lines.reduce((max, line) => Math.max(max, line.length), 0);
    return lines.map((line) => {
      const chars = [...line];
      while (chars.length < width) chars.push('#'); // 短い行は壁で埋めて矩形を保つ
      return chars;
    });
  }

  parseFacilities(root) {
    const scriptEl = root.querySelector('[data-role="rpg-village-facilities"]');
    let list = [];
    try {
      list = JSON.parse(scriptEl?.textContent || '[]');
    } catch (err) {
      console.error('施設データの読み込みに失敗しました', err);
    }
    const byTile = new Map();
    // 出口が未設定の時はliquid側がnullを1件挟むので、ここで除去する
    list.filter(Boolean).forEach((facility) => {
      byTile.set(`${facility.row},${facility.col}`, facility);
    });
    return byTile;
  }

  // 村人（マップ上をランダムに歩き回り、ぶつかると会話するNPC）。初期位置に加え、
  // 移動中の状態（moveDirection/moveProgress/facing）と次に動ける時刻（idleUntil）を持たせる
  parseVillagers(root) {
    const scriptEl = root.querySelector('[data-role="rpg-village-villagers"]');
    let list = [];
    try {
      list = JSON.parse(scriptEl?.textContent || '[]');
    } catch (err) {
      console.error('村人データの読み込みに失敗しました', err);
    }
    return list.filter(Boolean).map((villager) => ({
      ...villager,
      row: this.clampRow(villager.startRow),
      col: this.clampCol(villager.startCol),
      facing: 'down',
      moveDirection: null,
      moveProgress: 0,
      idleUntil: 0,
    }));
  }

  parseImages(root) {
    const scriptEl = root.querySelector('[data-role="rpg-village-images"]');
    try {
      return JSON.parse(scriptEl?.textContent || '{}');
    } catch (err) {
      console.error('画像データの読み込みに失敗しました', err);
      return {};
    }
  }

  parseIntroLines(root) {
    const scriptEl = root.querySelector('[data-role="rpg-village-intro-lines"]');
    try {
      return JSON.parse(scriptEl?.textContent || '[]');
    } catch (err) {
      console.error('オープニングのセリフデータの読み込みに失敗しました', err);
      return [];
    }
  }

  // タイル画像は「ぴぽや」等の複数マスが並んだシートをそのまま設定できるようにしてあるため、
  // シート内のcol/row（1始まり）とsheetTileSizeから、切り出す元矩形（sx, sy）をタイル文字ごとに覚えておく。
  // マップ上に常時描く画像（タイル・プレイヤー・施設・村人）に加え、会話テロップでしか使わない
  // 画像（会話アイコン・吹き出し用イメージ・お城アイコン等）もここで全て先読みし、揃うまでstart()を待たせる
  preloadImages() {
    this.sheetTileSize = parseInt(this.images.sheetTileSize, 10) || RPG_VILLAGE_TILE_SIZE;
    this.tileSpriteRects = {};
    const promises = [];

    const tiles = this.images.tiles || {};
    Object.entries(tiles).forEach(([tileChar, tile]) => {
      if (!tile || !tile.url) return;
      const col = parseInt(tile.col, 10) || 1;
      const row = parseInt(tile.row, 10) || 1;
      this.tileSpriteRects[tileChar] = {
        sx: (col - 1) * this.sheetTileSize,
        sy: (row - 1) * this.sheetTileSize,
      };
      promises.push(this.loadImage(tile.url).then((img) => { this.loadedImages[tileChar] = img; }));
    });

    if (this.images.player) {
      promises.push(
        this.loadImage(this.images.player).then((img) => {
          // 村人と同じ「ぴぽや」形式のキャラチップ（96x128px＝32px角×3列4行）ならコマ切り出し描画にする。
          // それ以外の通常画像（1枚絵・GIF等）はそのまま拡大縮小して見せる（切り出し前提だと一部だけ表示されてしまう）
          this.playerIsCharachip = img.naturalWidth === RPG_VILLAGE_TILE_SIZE * 3 && img.naturalHeight === RPG_VILLAGE_TILE_SIZE * 4;
          this.loadedImages.player = img;
        })
      );
    }

    this.facilities.forEach((facility) => {
      if (facility.image) {
        promises.push(this.loadImage(facility.image).then((img) => { facility.loadedImage = img; }));
      }
      this.collectPresentationUrls(facility).forEach((url) => promises.push(this.loadImage(url)));
    });

    this.villagers.forEach((villager) => {
      if (villager.charachip) {
        promises.push(this.loadImage(villager.charachip).then((img) => { villager.loadedImage = img; }));
      }
      this.collectPresentationUrls(villager).forEach((url) => promises.push(this.loadImage(url)));
    });

    this.introLines.forEach((line) => {
      if (line.icon) promises.push(this.loadImage(line.icon));
    });
    if (this.castleIconUrl) promises.push(this.loadImage(this.castleIconUrl));

    return Promise.all(promises);
  }

  // 施設・村人共通：マップ上には描かれないが会話テロップで使う画像（吹き出し用イメージ・
  // 顔アイコンのフォールバック・会話セリフごとのアイコンA/B）のURL一覧
  collectPresentationUrls(entity) {
    const urls = [];
    if (entity.promptImage) urls.push(entity.promptImage);
    if (entity.faceIcon) urls.push(entity.faceIcon);
    (entity.conversations || []).forEach((pattern) => {
      if (pattern.iconA) urls.push(pattern.iconA);
      if (pattern.iconB) urls.push(pattern.iconB);
    });
    return urls;
  }

  // 画像を1枚読み込むPromise。失敗時も読み込み中画面のまま止まらないようresolveする
  loadImage(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => resolve(img);
      img.src = url;
    });
  }

  // ---- 進行状況（現在地）の保存 ----
  // 保存データには、保存した時点のstart_row/start_col設定も一緒に記録しておく。
  // テーマカスタマイズ側で開始位置の設定を変更した時、古い保存位置がいつまでも
  // 優先されて新しい設定が反映されないのを防ぐため（設定が変わっていたら再訪問扱いにしない）
  loadSavedPosition() {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (
        Number.isInteger(data.row) &&
        Number.isInteger(data.col) &&
        data.startRow === this.startRow &&
        data.startCol === this.startCol &&
        this.isWalkable(data.row, data.col)
      ) {
        return data;
      }
    } catch (err) {
      // 読み込めない場合はデフォルトの開始地点を使う
    }
    return null;
  }

  savePosition() {
    try {
      localStorage.setItem(
        this.storageKey,
        JSON.stringify({ row: this.tileRow, col: this.tileCol, startRow: this.startRow, startCol: this.startCol })
      );
    } catch (err) {
      console.error('現在地の保存に失敗しました', err);
    }
  }

  clampRow(row) {
    return Math.max(0, Math.min(row, this.map.length - 1));
  }

  clampCol(col) {
    const width = this.map[0]?.length || 1;
    return Math.max(0, Math.min(col, width - 1));
  }

  // ---- 当たり判定 ----
  isWalkable(row, col) {
    if (row < 0 || col < 0 || row >= this.map.length || col >= (this.map[0]?.length || 0)) return false;
    if (this.facilities.has(`${row},${col}`)) return true; // 施設タイルは地形に関わらず進入可
    const tile = this.map[row][col];
    return RPG_VILLAGE_WALKABLE_CHARS.has(tile);
  }

  isCastleTile(row, col) {
    const tile = this.map[row]?.[col];
    return tile ? RPG_VILLAGE_CASTLE_CHARS.has(tile) : false;
  }

  // ---- キー入力 ----
  bindKeyboard() {
    const keyToDir = {
      ArrowUp: RPG_VILLAGE_DIRECTIONS.up,
      ArrowDown: RPG_VILLAGE_DIRECTIONS.down,
      ArrowLeft: RPG_VILLAGE_DIRECTIONS.left,
      ArrowRight: RPG_VILLAGE_DIRECTIONS.right,
      w: RPG_VILLAGE_DIRECTIONS.up,
      s: RPG_VILLAGE_DIRECTIONS.down,
      a: RPG_VILLAGE_DIRECTIONS.left,
      d: RPG_VILLAGE_DIRECTIONS.right,
    };

    window.addEventListener('keydown', (event) => {
      const dir = keyToDir[event.key] || keyToDir[event.key?.toLowerCase()];
      if (!dir) return;
      event.preventDefault();
      this.pushDirection(event.key, dir);
    });

    window.addEventListener('keyup', (event) => {
      if (keyToDir[event.key] || keyToDir[event.key?.toLowerCase()]) {
        this.popDirection(event.key);
      }
    });

    // フォーカスが外れると押しっぱなしキーのkeyupが発火せずheldDirectionsに残り続け、
    // 「ずっと同じ方向に歩き続ける」バグになるため、フォーカスが外れた時点で強制的に全解除する
    window.addEventListener('blur', () => {
      this.heldDirections = [];
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.heldDirections = [];
    });
  }

  // ---- キーボードフォーカス ----
  // テーマエディターのプレビューは多重にiframeが入れ子になっており、canvasが既定で
  // キーボードフォーカスを受け取れないと、クリックは効くのにキー入力だけ届かなくなる。
  // canvasをフォーカス可能にし、セクション内クリック時に明示的にフォーカスを当てて防ぐ
  bindFocus() {
    if (!this.canvas) return;
    this.root.addEventListener('pointerdown', () => {
      this.canvas.focus();
      // クリック/タップも「操作した」扱いにしてBGMの再生解禁を試みる（詳細はbindBgm()参照）
      this.tryPlayBgm();
    });
    this.canvas.focus();
  }

  // ---- BGM ----
  // ショピダンジョンと同じくループ再生＋オン/オフボタン。ブラウザは音付き自動再生を
  // ユーザー操作なしではブロックするため、ページ読み込み時点では再生を試みない。
  // window全体に1回だけの'keydown'/'pointerdown'リスナーを張る方式は、施設側の
  // stopPropagation等に阻まれて発火しないことがあったため、実際に効いている操作の
  // ハンドラ（pushDirection・bindFocusのpointerdown）から直接tryPlayBgm()を呼んでいる
  bindBgm() {
    if (this.bgmEl) this.bgmEl.volume = 0.4;

    if (!this.bgmToggleEl) return;
    this.bgmToggleEl.addEventListener('click', (event) => {
      event.stopPropagation();
      this.bgmEnabled = !this.bgmEnabled;
      this.bgmToggleEl.textContent = this.bgmEnabled ? '🔊' : '🔇';
      this.bgmToggleEl.setAttribute('aria-pressed', String(this.bgmEnabled));
      if (this.bgmEnabled) this.tryPlayBgm();
      else if (this.bgmEl) this.bgmEl.pause();
    });
  }

  tryPlayBgm() {
    if (!this.bgmEl || !this.bgmEnabled) return;
    // 移動のたびに何度も呼ばれるため、まだ再生されていない（=paused）時だけ先頭に戻す。
    // そうしないと歩くたびに巻き戻る一方、ブラウザが再生位置をページ遷移をまたいで覚えていて
    // 途中から再生してしまうことがあるため、他施設から戻った時も毎回最初から再生されるようにする
    if (this.bgmEl.paused) {
      this.bgmEl.currentTime = 0;
    }
    this.bgmEl.play().catch(() => {});
  }

  // ---- 画面下の十字ボタン（スマホ操作） ----
  bindDpad() {
    const dirs = RPG_VILLAGE_DIRECTIONS;
    this.root.querySelectorAll('[data-dpad]').forEach((btn) => {
      const dir = dirs[btn.dataset.dpad];
      if (!dir) return;
      const key = `dpad-${btn.dataset.dpad}`;
      const press = (event) => {
        event.preventDefault();
        // このボタン操作由来のclickでテロップを進めさせないためのフラグ（bindTelop()参照）。
        // クリック位置（要素の重なり）判定は指/カーソルのズレで確実でないため、時間軸で判定する
        this.suppressTelopClick = true;
        this.pushDirection(key, dir);
      };
      const release = () => {
        this.popDirection(key);
        // clickは同じ一連の操作の中でpointerup直後に同期的に発火するため、次のタスクまで
        // 解除を遅らせれば、その1回のclickだけを確実に無視できる
        setTimeout(() => {
          this.suppressTelopClick = false;
        }, 0);
      };
      btn.addEventListener('pointerdown', press);
      btn.addEventListener('pointerup', release);
      btn.addEventListener('pointerleave', release);
      btn.addEventListener('pointercancel', release);
    });
  }

  pushDirection(key, dir) {
    // 矢印キー・十字ボタンでの移動は最も確実に発火する操作なので、BGMの再生解禁も
    // ここで直接試みる（詳細はbindBgm()のコメント参照）
    this.tryPlayBgm();
    if (this.heldDirections.some((entry) => entry.key === key)) return;
    this.heldDirections.push({ key, ...dir });
    // 素早いタップだと次のrAFより前にpointerup（popDirection）が来て取りこぼすことがあるため、
    // 押された時点で即座に1マス分の移動を試みる（長押しはそのままupdate()側のループが継続する）
    this.tryStartMove();
  }

  popDirection(key) {
    this.heldDirections = this.heldDirections.filter((entry) => entry.key !== key);
  }

  currentDirection() {
    return this.heldDirections[this.heldDirections.length - 1] || null;
  }

  // ---- テロップの入力バインド ----
  // テロップ自体の表示ロジックはRPGVillageTelopに任せ、ここでは「何をきっかけに進めるか」だけを扱う
  bindTelop() {
    if (!this.telop.overlayEl) return;
    this.telop.overlayEl.addEventListener('click', (event) => {
      // ここでstopPropagationしないと、この後ろで登録するroot側のクリックでも
      // advance()が呼ばれてしまい、1回のクリックで2行分進んでしまう
      event.stopPropagation();
      this.telop.advance();
    });
    // テロップの吹き出し以外（マップ上のどこでも）をクリックしても進められるようにする。
    // ただしdpadを押して村人にぶつかり会話が始まった直後、離した拍子のclickまで拾うと
    // 開いた瞬間に1行進んで即座に閉じたように見えるため、dpad操作中はsuppressTelopClickで除外する
    this.root.addEventListener('click', () => {
      if (this.suppressTelopClick) return;
      if (this.telop.active) this.telop.advance();
    });
    window.addEventListener('keydown', (event) => {
      if (!this.telop.active) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.telop.advance();
      }
    });
    // 初回訪問の時だけオープニングの会話を再生する（施設から戻ってきた・再訪問の時は
    // 毎回押させられるのが煩わしいのでスキップし、すぐ散策できるようにする）
    if (this.isFirstVisit) this.telop.play(this.introLines);
  }

  // 施設・村人共通の会話組み立て処理。会話セリフ1〜3（entity.conversations）から、話しかける
  // たびに1パターンずつ順番に選ぶ（idごとに順番を記憶。空欄のパターンはliquid側で除外済み）。
  // 各行のアイコンは話者名では判定せず（違う名前だと常にアイコンB扱いになるため）、
  // 行の順番で単純に交互切り替えする（1・3・5行目=アイコンA、2・4・6行目=アイコンB）
  pickDialogueLines(entity, fallbackIcon) {
    const patterns = entity.conversations || [];
    if (patterns.length === 0) return [];

    const count = this.eventVisitCounts[entity.id] || 0;
    const pattern = patterns[count % patterns.length];
    this.eventVisitCounts[entity.id] = count + 1;

    const lines = (pattern.text || '').split(/\r?\n/).map((s) => s.trim()).filter(Boolean);
    const iconA = pattern.iconA || fallbackIcon;
    const iconB = pattern.iconB || iconA;

    const hasOwnSpeaker = (text) => /^.+?「.+」$/.test(text);
    return lines.map((text, index) => {
      const finalText = hasOwnSpeaker(text) || !entity.title ? text : `${entity.title}「${text}」`;
      const icon = index % 2 === 0 ? iconA : iconB;
      return { icon, text: finalText };
    });
  }

  // ---- 入場プロンプト（施設） / 確認プロンプト（出口） ----
  bindEntryPrompt() {
    if (!this.entryPromptEl) return;
    // 施設用は本物の<a href="#">にしてある。ブラウザ標準の「フォーカス中のリンクは
    // Enterでクリック扱いになる」という挙動に乗るため（独自のkeydown監視だけに頼らない）
    if (this.entryLinkEl) {
      this.entryLinkEl.addEventListener('click', (event) => {
        event.preventDefault();
        // stopPropagationしないと、root側の「テロップ以外クリックで進む」リスナーにも届いてしまい、
        // confirmActiveFacility()が会話ポップアップを開いた直後にadvance()が呼ばれ即座に閉じてしまう
        event.stopPropagation();
        this.confirmActiveFacility();
      });
    }
    // 保険として、keydownでの確定も引き続き効くようにしておく（出口のYES/NOもこちら経由）
    window.addEventListener('keydown', (event) => {
      if (this.telop.active || !this.activeFacility) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        // stopImmediatePropagationしないと、同じwindowに登録されたbindTelop()側のkeydown
        // リスナーにも届き、会話ポップアップを開いた直後にadvance()が呼ばれ1行目を読めずに進んでしまう
        event.stopImmediatePropagation();
        this.confirmActiveFacility(); // 出口の場合もEnter/SpaceはYES扱い
      }
    });
  }

  // ---- 出口のYES/NOボタン ----
  bindExitChoices() {
    if (this.exitYesBtn) {
      this.exitYesBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        this.confirmActiveFacility();
      });
    }
    if (this.exitNoBtn) {
      this.exitNoBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        if (this.entryPromptEl) this.entryPromptEl.hidden = true;
      });
    }
  }

  // 施設・出口共通の「確定」処理。リンク先が「#」の施設は会話ポップアップを再生し、
  // それ以外はリンク先へ遷移する
  confirmActiveFacility() {
    if (!this.activeFacility) return;
    if (this.activeFacility.link === '#') {
      if (this.entryPromptEl) this.entryPromptEl.hidden = true;
      this.telop.play(this.pickDialogueLines(this.activeFacility, this.activeFacility.image));
      return;
    }
    if (!this.activeFacility.link) return;
    this.savePosition();
    window.location.href = this.activeFacility.link;
  }

  checkFacilityAtCurrentTile() {
    const facility = this.facilities.get(`${this.tileRow},${this.tileCol}`) || null;
    if (facility === this.activeFacility) return;
    this.activeFacility = facility;
    if (!this.entryPromptEl) return;
    // テロップ再生中は、保存済みの現在地が施設タイルと重なっていても
    // 入場プロンプトを出さない（テロップと重なって表示されるのを防ぐ）
    if (facility && !this.telop.active) {
      if (facility.isExit) {
        if (this.entryTitleEl) this.entryTitleEl.textContent = facility.message || '';
        if (this.entryDescEl) this.entryDescEl.textContent = '';
        if (this.entryImageEl) this.entryImageEl.hidden = true;
        if (this.entryLinkEl) this.entryLinkEl.hidden = true;
        if (this.entryChoicesEl) this.entryChoicesEl.hidden = false;
        if (this.exitYesBtn) this.exitYesBtn.focus();
        // 出口はマップ下端にあることが多く、施設と同じ「アイコン真下」配置だと画面外に
        // はみ出て見えなくなるケースがあるため、右横に出す
        this.entryPromptEl.classList.remove('rpg-village-map-entry-prompt--floating');
        this.entryPromptEl.classList.add('rpg-village-map-entry-prompt--floating-side');
        // 位置計算はプロンプト自身の表示幅（offsetWidth）を使うため、hidden解除を先に行う
        this.entryPromptEl.hidden = false;
        this.positionPromptRightOfFacility(facility);
      } else {
        // リンク先が「#」の施設は会話ポップアップ用なので、説明文（セリフ本文）はここでは見せない
        const isPopup = facility.link === '#';
        if (this.entryTitleEl) this.entryTitleEl.textContent = `▶ ${facility.title} ${facility.entrySuffix || 'に入る'}`;
        if (this.entryDescEl) this.entryDescEl.textContent = isPopup ? '' : (facility.description || '');
        if (this.entryImageEl) {
          if (facility.promptImage) {
            this.entryImageEl.src = facility.promptImage;
            this.entryImageEl.hidden = false;
          } else {
            this.entryImageEl.hidden = true;
          }
        }
        if (this.entryChoicesEl) this.entryChoicesEl.hidden = true;
        if (this.entryLinkEl) {
          this.entryLinkEl.hidden = false;
          this.entryLinkEl.focus();
        }
        // 施設のプロンプトは、右上固定ではなくアイコンの真下に出す
        this.entryPromptEl.classList.remove('rpg-village-map-entry-prompt--floating-side');
        this.entryPromptEl.classList.add('rpg-village-map-entry-prompt--floating');
        // 位置計算はプロンプト自身の表示幅（offsetWidth）を使うため、hidden解除を先に行う
        this.entryPromptEl.hidden = false;
        this.positionPromptNearFacility(facility);
      }
    } else {
      this.entryPromptEl.hidden = true;
    }
  }

  // canvasのロジカル座標系にあるタイルが、canvas-wrap基準の画面px上でどこに描画されているかを返す
  // （カメラのオフセットと、実際のCSS表示サイズへのスケール変換を考慮する）
  tileScreenRect(row, col) {
    if (!this.canvas) return null;
    const viewportW = this.viewportCols * RPG_VILLAGE_TILE_SIZE;
    const viewportH = this.viewportRows * RPG_VILLAGE_TILE_SIZE;
    const mapW = (this.map[0]?.length || 0) * RPG_VILLAGE_TILE_SIZE;
    const mapH = this.map.length * RPG_VILLAGE_TILE_SIZE;

    const playerX = this.renderX();
    const playerY = this.renderY();
    const cameraX = this.clampCamera(playerX + RPG_VILLAGE_TILE_SIZE / 2 - viewportW / 2, mapW, viewportW);
    const cameraY = this.clampCamera(playerY + RPG_VILLAGE_TILE_SIZE / 2 - viewportH / 2, mapH, viewportH);

    const canvasRect = this.canvas.getBoundingClientRect();
    // canvasとcanvas-wrap（親）のbounding rectがズレるケースに備えて差分を補正する
    const wrapRect = this.canvas.parentElement.getBoundingClientRect();
    const offsetX = canvasRect.left - wrapRect.left;
    const offsetY = canvasRect.top - wrapRect.top;
    const scale = (canvasRect.width || viewportW) / viewportW;

    return {
      left: offsetX + (col * RPG_VILLAGE_TILE_SIZE - cameraX) * scale,
      top: offsetY + (row * RPG_VILLAGE_TILE_SIZE - cameraY) * scale,
      size: RPG_VILLAGE_TILE_SIZE * scale,
    };
  }

  // 施設アイコンの真下にプロンプトを出す。左右端に近い施設だとそのままでは画面外にはみ出て
  // 見切れてしまうため、表示領域内に収まるよう中心位置を左右にクランプする
  positionPromptNearFacility(facility) {
    if (!this.entryPromptEl || !this.canvas) return;
    const tile = this.tileScreenRect(facility.row, facility.col);
    if (!tile) return;
    const containerWidth = this.canvas.parentElement.clientWidth;
    const boxWidth = this.entryPromptEl.offsetWidth;
    const margin = 8;
    const idealCenterX = tile.left + tile.size / 2;
    const minCenterX = boxWidth / 2 + margin;
    const maxCenterX = Math.max(minCenterX, containerWidth - boxWidth / 2 - margin);
    const centerX = Math.min(Math.max(idealCenterX, minCenterX), maxCenterX);
    this.entryPromptEl.style.left = `${centerX}px`;
    this.entryPromptEl.style.top = `${tile.top + tile.size + 6}px`;
  }

  // 出口の確認は、施設と違い右横に出す（マップ下端にあることが多く、真下配置だと画面外に
  // はみ出て見えなくなるケースがあるため）。右端に近い出口だとはみ出るため左右をクランプする
  positionPromptRightOfFacility(facility) {
    if (!this.entryPromptEl || !this.canvas) return;
    const tile = this.tileScreenRect(facility.row, facility.col);
    if (!tile) return;
    const containerWidth = this.canvas.parentElement.clientWidth;
    const boxWidth = this.entryPromptEl.offsetWidth;
    const margin = 8;
    const idealLeft = tile.left + tile.size + 6;
    const maxLeft = Math.max(margin, containerWidth - boxWidth - margin);
    const left = Math.min(Math.max(idealLeft, margin), maxLeft);
    this.entryPromptEl.style.left = `${left}px`;
    this.entryPromptEl.style.top = `${tile.top + tile.size / 2}px`;
  }

  // ---- ゲームループ ----
  tick(time) {
    if (this.lastFrameTime === null) this.lastFrameTime = time;
    const dt = time - this.lastFrameTime;
    this.lastFrameTime = time;

    this.update(dt);
    this.draw();

    this.frameHandle = requestAnimationFrame((t) => this.tick(t));
  }

  // 現在保持している方向へ、まだ移動中でなければ1マス分の移動を開始する
  tryStartMove() {
    if (this.telop.active || this.moveDirection) return;
    const dir = this.currentDirection();
    if (!dir) return;
    this.facing = dir.facing;
    const targetRow = this.tileRow + dir.dr;
    const targetCol = this.tileCol + dir.dc;
    // 村人がいるマスに進もうとした場合は、移動せずに話しかける（ぶつかって会話する形）
    const villager = this.getVillagerAt(targetRow, targetCol);
    if (villager) {
      this.talkToVillager(villager, dir);
      return;
    }
    // 城タイルにぶつかった場合も、進入不可のまま会話だけ発生させる
    if (this.isCastleTile(targetRow, targetCol)) {
      this.talkToCastle();
      return;
    }
    if (this.isWalkable(targetRow, targetCol)) {
      this.moveDirection = dir;
      this.moveProgress = 0;
    }
  }

  // villagerが指定マスを占有しているか判定する。移動アニメーション中はrow/colがまだ出発マスの
  // ままなので、移動先マスも占有中とみなさないと、移動中の村人を勇者や他の村人がすり抜けてしまう
  villagerOccupiesTile(villager, row, col) {
    if (villager.row === row && villager.col === col) return true;
    if (villager.moveDirection) {
      const destRow = villager.row + villager.moveDirection.dr;
      const destCol = villager.col + villager.moveDirection.dc;
      if (destRow === row && destCol === col) return true;
    }
    return false;
  }

  // 指定したマス（移動中の移動先も含む）にいる村人を返す
  getVillagerAt(row, col) {
    return this.villagers.find((villager) => this.villagerOccupiesTile(villager, row, col)) || null;
  }

  update(dt) {
    this.updateVillagers(dt);
    if (this.telop.active) return; // テロップ（オープニング・会話ポップアップ）を閉じるまでは移動を受け付けない
    if (!this.moveDirection) {
      this.tryStartMove();
      return;
    }

    this.moveProgress += dt / RPG_VILLAGE_MOVE_MS;
    if (this.moveProgress >= 1) {
      this.tileRow += this.moveDirection.dr;
      this.tileCol += this.moveDirection.dc;
      this.moveDirection = null;
      this.moveProgress = 0;
      this.savePosition();
      this.checkFacilityAtCurrentTile();
    }
  }

  // ---- 村人（NPC）のランダム移動 ----
  // 移動中の村人はそのまま完了させ、静止中の村人は一定確率・間隔でランダムな方向へ1マス移動を試みる
  // （歩けない・他の村人や勇者がいる場合はその場に留まる）
  updateVillagers(dt) {
    if (this.telop.active) return; // 会話中は勇者と同じく村人も動かない
    const now = performance.now();
    const dirs = Object.values(RPG_VILLAGE_DIRECTIONS);
    this.villagers.forEach((villager) => {
      if (villager.moveDirection) {
        villager.moveProgress += dt / RPG_VILLAGE_VILLAGER_MOVE_MS;
        if (villager.moveProgress >= 1) {
          villager.row += villager.moveDirection.dr;
          villager.col += villager.moveDirection.dc;
          villager.moveDirection = null;
          villager.moveProgress = 0;
          villager.idleUntil = now + this.randomVillagerIdleMs();
        }
        return;
      }
      if (now < villager.idleUntil) return;
      if (Math.random() < RPG_VILLAGE_VILLAGER_STAY_CHANCE) {
        villager.idleUntil = now + this.randomVillagerIdleMs();
        return;
      }
      const dir = dirs[Math.floor(Math.random() * dirs.length)];
      villager.facing = dir.facing;
      const targetRow = villager.row + dir.dr;
      const targetCol = villager.col + dir.dc;
      const blocked =
        !this.isWalkable(targetRow, targetCol) ||
        this.facilities.has(`${targetRow},${targetCol}`) || // 施設タイルの上には乗らせない
        (targetRow === this.tileRow && targetCol === this.tileCol) || // 勇者のいるマスには進まない
        this.villagers.some((other) => other !== villager && this.villagerOccupiesTile(other, targetRow, targetCol));
      if (blocked) {
        villager.idleUntil = now + this.randomVillagerIdleMs();
        return;
      }
      villager.moveDirection = dir;
      villager.moveProgress = 0;
    });
  }

  randomVillagerIdleMs() {
    return RPG_VILLAGE_VILLAGER_IDLE_MIN_MS + Math.random() * RPG_VILLAGE_VILLAGER_IDLE_RANGE_MS;
  }

  talkToVillager(villager, playerDir) {
    if (this.telop.active) return;
    const lines = this.pickDialogueLines(villager, villager.faceIcon);
    if (lines.length === 0) return;
    // ぶつかった方向から、村人が勇者の方を振り返るようにする（移動中だった場合は歩みも止める）
    if (playerDir) villager.facing = RPG_VILLAGE_OPPOSITE_FACING[playerDir.facing] || villager.facing;
    villager.moveDirection = null;
    villager.moveProgress = 0;
    this.telop.play(lines);
  }

  talkToCastle() {
    if (this.telop.active || !this.castleMessage) return;
    // 城にぶつかった時の移動方向によっては勇者が後ろ向き（up）のまま話し始めてしまうため、
    // 会話中は常にこちらを向かせる
    this.facing = 'down';
    this.telop.play([{ icon: this.castleIconUrl, text: this.castleMessage }]);
  }

  // ---- 描画 ----
  // スマホでは縦の表示マス数を増やして画面を埋めるが（RPG_VILLAGE_VIEWPORT_ROWS_MOBILE）、
  // マップの実際の行数より多いとカメラが上下に無駄なレターボックス余白を作ってしまうため、それを超えないようにする
  computeViewportRows() {
    const desired = RPG_VILLAGE_MOBILE_QUERY.matches ? RPG_VILLAGE_VIEWPORT_ROWS_MOBILE : RPG_VILLAGE_VIEWPORT_ROWS;
    return Math.min(desired, this.map.length);
  }

  // PCは高さをCSS側（.rpg-village-map-stage）で固定しているため、その高さで実際に収まる
  // タイルサイズを逆算し、画面幅に収まる列数を動的に決める（幅が広いほど多くの列を表示する）。
  // スマホは今まで通りRPG_VILLAGE_VIEWPORT_COLS固定（高さ側をROWS_MOBILEで可変にしている）
  computeViewportCols() {
    if (RPG_VILLAGE_MOBILE_QUERY.matches || !this.canvas) {
      return Math.min(RPG_VILLAGE_VIEWPORT_COLS, this.map[0]?.length || RPG_VILLAGE_VIEWPORT_COLS);
    }
    const heightPx = this.canvas.getBoundingClientRect().height || this.viewportRows * RPG_VILLAGE_TILE_SIZE;
    const tileSizePx = heightPx / this.viewportRows;
    const widthBudget = this.root.clientWidth || RPG_VILLAGE_VIEWPORT_COLS * RPG_VILLAGE_TILE_SIZE;
    const desired = Math.max(1, Math.floor(widthBudget / tileSizePx));
    return Math.min(desired, this.map[0]?.length || desired);
  }

  // 描画コードは常にロジカルなビューポート座標（0〜viewportCols*TILE_SIZE等）で書き、
  // バッキングストアの解像度はCSS上の実表示サイズ（+devicePixelRatio）に合わせて毎回計算し直す。
  // dprだけでwidth/heightを固定すると、CSS側で大きく表示するほど引き伸ばされてぼやけてしまう
  setupCanvasScale() {
    if (!this.canvas) return;
    // canvasの縦横比（PCは列数が可変なので毎回計算し直す）をCSS側にも反映し、
    // 描画されない余白（レターボックス）が画面上の空白として残らないようにする
    this.viewportCols = this.computeViewportCols();
    this.canvas.style.aspectRatio = `${this.viewportCols} / ${this.viewportRows}`;
    const dpr = window.devicePixelRatio || 1;
    const logicalWidth = this.viewportCols * RPG_VILLAGE_TILE_SIZE;
    const logicalHeight = this.viewportRows * RPG_VILLAGE_TILE_SIZE;
    const displayWidth = this.canvas.getBoundingClientRect().width || logicalWidth;
    const scale = (displayWidth / logicalWidth) * dpr;
    this.canvas.width = logicalWidth * scale;
    this.canvas.height = logicalHeight * scale;
    this.ctx.setTransform(scale, 0, 0, scale, 0, 0);
  }

  renderX() {
    return (this.tileCol + (this.moveDirection ? this.moveDirection.dc * this.moveProgress : 0)) * RPG_VILLAGE_TILE_SIZE;
  }

  renderY() {
    return (this.tileRow + (this.moveDirection ? this.moveDirection.dr * this.moveProgress : 0)) * RPG_VILLAGE_TILE_SIZE;
  }

  draw() {
    if (!this.ctx) return;
    const viewportW = this.viewportCols * RPG_VILLAGE_TILE_SIZE;
    const viewportH = this.viewportRows * RPG_VILLAGE_TILE_SIZE;
    const mapW = (this.map[0]?.length || 0) * RPG_VILLAGE_TILE_SIZE;
    const mapH = this.map.length * RPG_VILLAGE_TILE_SIZE;

    const playerX = this.renderX();
    const playerY = this.renderY();

    const cameraX = this.clampCamera(playerX + RPG_VILLAGE_TILE_SIZE / 2 - viewportW / 2, mapW, viewportW);
    const cameraY = this.clampCamera(playerY + RPG_VILLAGE_TILE_SIZE / 2 - viewportH / 2, mapH, viewportH);

    this.ctx.clearRect(0, 0, viewportW, viewportH);

    const firstCol = Math.floor(cameraX / RPG_VILLAGE_TILE_SIZE);
    const firstRow = Math.floor(cameraY / RPG_VILLAGE_TILE_SIZE);
    const lastCol = Math.ceil((cameraX + viewportW) / RPG_VILLAGE_TILE_SIZE);
    const lastRow = Math.ceil((cameraY + viewportH) / RPG_VILLAGE_TILE_SIZE);

    for (let row = firstRow; row < lastRow; row++) {
      for (let col = firstCol; col < lastCol; col++) {
        const tile = this.map[row]?.[col];
        if (!tile) continue;
        const x = col * RPG_VILLAGE_TILE_SIZE - cameraX;
        const y = row * RPG_VILLAGE_TILE_SIZE - cameraY;
        const facility = this.facilities.get(`${row},${col}`);

        // 'base'（例:木'T'の下地='道','）を持つタイルは、下地の見た目を先に描いてから自分のスプライトを
        // 重ねる。これにより木を敷き詰めても下地の質感が繋がって見え、色の継ぎ目が出ない
        const tileConfig = this.images.tiles && this.images.tiles[tile];
        const baseChar = (tileConfig && tileConfig.base) || tile;

        this.ctx.fillStyle = RPG_VILLAGE_TILE_COLORS[baseChar] || '#333';
        this.ctx.fillRect(x, y, RPG_VILLAGE_TILE_SIZE + 1, RPG_VILLAGE_TILE_SIZE + 1);

        if (baseChar !== tile) this.drawTileSprite(baseChar, x, y);
        this.drawTileSprite(tile, x, y);

        if (facility) this.drawFacility(facility, x, y);
      }
    }

    this.drawVillagers(cameraX, cameraY);
    this.drawPlayer(playerX - cameraX, playerY - cameraY);
  }

  clampCamera(value, mapSize, viewportSize) {
    if (mapSize <= viewportSize) return (mapSize - viewportSize) / 2;
    return Math.max(0, Math.min(value, mapSize - viewportSize));
  }

  // タイル文字char用のスプライトが読み込み済みなら、シートから1マス分だけ切り出して描く
  drawTileSprite(char, x, y) {
    const img = this.loadedImages[char];
    if (!img) return;
    // 非整数倍スケール時に隣接タイルの境界へ丸め誤差の隙間線が出ないよう、1px分だけ重ねて描く
    const rect = this.tileSpriteRects[char];
    if (rect) {
      this.ctx.drawImage(
        img,
        rect.sx,
        rect.sy,
        this.sheetTileSize,
        this.sheetTileSize,
        x,
        y,
        RPG_VILLAGE_TILE_SIZE + 1,
        RPG_VILLAGE_TILE_SIZE + 1
      );
    } else {
      this.ctx.drawImage(img, x, y, RPG_VILLAGE_TILE_SIZE + 1, RPG_VILLAGE_TILE_SIZE + 1);
    }
  }

  drawFacility(facility, x, y) {
    const size = RPG_VILLAGE_TILE_SIZE;
    if (facility.loadedImage) {
      this.ctx.drawImage(facility.loadedImage, x, y, size, size);
      return;
    }
    // 出口はアイコン未設定なら目印を重ねず、下の地形（道）のまま見せる
    if (facility.isExit) return;
    this.ctx.fillStyle = '#ffd76a';
    this.ctx.fillRect(x + 2, y + 2, size - 4, size - 4);
    this.ctx.fillStyle = '#14100b';
    this.ctx.font = 'bold 14px sans-serif';
    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';
    this.ctx.fillText((facility.title || '?').charAt(0), x + size / 2, y + size / 2);
  }

  // 村人（NPC）を描く。「ぴぽや」形式のキャラチップ（3列4行＝歩行3コマ×下左右上4方向、
  // 32px角）を前提に、向き（facing）で参照する行を、歩行中かどうかで参照する列（コマ）を切り替える
  drawVillagers(cameraX, cameraY) {
    const size = RPG_VILLAGE_TILE_SIZE;
    // マス(size)より一回り小さく描画し、足元がマス下端に揃うよう縦横で余白の配分を変える
    const drawSize = size * RPG_VILLAGE_NPC_SCALE;
    const offsetX = (size - drawSize) / 2;
    const offsetY = size - drawSize;
    this.villagers.forEach((villager) => {
      if (!villager.loadedImage) return; // 画像読み込み前は表示しない（施設のような色プレースホルダーは持たない）
      const renderCol = villager.col + (villager.moveDirection ? villager.moveDirection.dc * villager.moveProgress : 0);
      const renderRow = villager.row + (villager.moveDirection ? villager.moveDirection.dr * villager.moveProgress : 0);
      const x = renderCol * size - cameraX + offsetX;
      const y = renderRow * size - cameraY + offsetY;

      // 歩行中は3コマ（0,1,2）を一定間隔で切り替えてアニメーションさせ、静止中は中央（立ち）コマにする
      const frame = villager.moveDirection ? Math.floor(performance.now() / 150) % 3 : 1;
      const srcRow = RPG_VILLAGE_CHARACHIP_ROW_BY_FACING[villager.facing] ?? 0;
      this.ctx.drawImage(
        villager.loadedImage,
        frame * size,
        srcRow * size,
        size,
        size,
        x,
        y,
        drawSize,
        drawSize
      );
    });
  }

  drawPlayer(x, y) {
    const size = RPG_VILLAGE_TILE_SIZE;
    const playerImg = this.loadedImages.player;
    if (playerImg && this.playerIsCharachip) {
      // 村人（drawVillagers）と同じ「ぴぽや」形式のキャラチップ（96x128px、3列4行）として描く。
      // 移動中は3コマを一定間隔で切り替え、静止中は中央（立ち）コマにする
      const frame = this.moveDirection ? Math.floor(performance.now() / 150) % 3 : 1;
      const srcRow = RPG_VILLAGE_PLAYER_ROW_BY_FACING[this.facing] ?? 0;
      this.ctx.drawImage(playerImg, frame * size, srcRow * size, size, size, x, y, size, size);
      return;
    }
    if (playerImg) {
      // キャラチップ形式ではない通常画像（1枚絵・GIF等）は、従来通りそのまま拡大縮小して見せる
      this.ctx.drawImage(playerImg, x, y, size, size);
      return;
    }
    // プレイヤー画像未設定時は円＋向きを示す三角形のプレースホルダーを描く
    this.ctx.fillStyle = '#e2564f';
    this.ctx.beginPath();
    this.ctx.arc(x + size / 2, y + size / 2, size / 2 - 3, 0, Math.PI * 2);
    this.ctx.fill();

    this.ctx.fillStyle = '#14100b';
    const cx = x + size / 2;
    const cy = y + size / 2;
    const r = size / 4;
    this.ctx.beginPath();
    if (this.facing === 'up') {
      this.ctx.moveTo(cx, cy - r);
      this.ctx.lineTo(cx - r, cy + r / 2);
      this.ctx.lineTo(cx + r, cy + r / 2);
    } else if (this.facing === 'down') {
      this.ctx.moveTo(cx, cy + r);
      this.ctx.lineTo(cx - r, cy - r / 2);
      this.ctx.lineTo(cx + r, cy - r / 2);
    } else if (this.facing === 'left') {
      this.ctx.moveTo(cx - r, cy);
      this.ctx.lineTo(cx + r / 2, cy - r);
      this.ctx.lineTo(cx + r / 2, cy + r);
    } else {
      this.ctx.moveTo(cx + r, cy);
      this.ctx.lineTo(cx - r / 2, cy - r);
      this.ctx.lineTo(cx - r / 2, cy + r);
    }
    this.ctx.closePath();
    this.ctx.fill();
  }
}

document.querySelectorAll('.rpg-village-map-section').forEach((root) => {
  // theme dev のホットリロード等で二重初期化されるのを防ぐ
  if (root.dataset.rpgVillageInitialized === 'true') return;
  root.dataset.rpgVillageInitialized = 'true';
  new RPGVillageMap(root);
});
